import CartObserver from 'UTILS/cart/CartObserver';
import buildSrcset from 'UTILS/DOM/buildSrcset';
import logger from 'UTILS/logger';
import { toPascalCase } from '../utilities/string';

// we can safely init the cart in any file and be sure it is the same instance in all files
// because the CartObserver is a Singleton.
const cart = new CartObserver();

function quickAddToCart() {
  const data = this.dataset;
  const input = this.closest('div').querySelector('input');
  if (input) {
    input.checked = true;
  }
  const payload = {
    id: parseInt(data.variantId, 10),
    quantity: 1,
  };
  cart.addToCart(payload);
}

function updateImages(productCard, newColor, media) {
  const mainImageContainer = productCard.querySelector('[data-id="product-image"]');
  const swapImageContainer = productCard.querySelector('[data-id="product-image-swap"]');
  const mainImage = mainImageContainer && mainImageContainer.querySelector('img');
  const swapImage = swapImageContainer && swapImageContainer.querySelector('img');
  const altTagColor = toPascalCase(newColor).replace(/ /g, '');

  const associatedMedia = media.filter((item) => {
    if (!item.alt) return false;

    return item.alt.includes(`(${altTagColor})`);
  });
  if (associatedMedia.length === 0) return;
  mainImage.alt = associatedMedia[0].alt;
  mainImage.src = associatedMedia[0].src;
  mainImage.srcset = buildSrcset(mainImage.srcset, mainImage.src);
  if (associatedMedia.length < 2) return;
  swapImage.alt = associatedMedia[1].alt;
  swapImage.src = associatedMedia[1].src;
  swapImage.srcset = buildSrcset(swapImage.srcset, swapImage.src);
}

function updateQuickAddBtns(productCard, relatedVariantIds) {
  const btns = productCard.querySelectorAll('[data-id="product-card-size-label"]');
  btns.forEach((btn, index) => {
    const newVariant = relatedVariantIds[index];
    if (newVariant) {
      // eslint-disable-next-line no-param-reassign
      btn.dataset.variantId = newVariant;
    }
  });
}

// update the quick add button data when other colors are selected
// this ensures the correct variant id are swapped on the button dataset
function variantUpdateHandler(e) {
  e.preventDefault();
  const el = e.currentTarget;
  const { value: color } = el.dataset;
  const productCard = el.closest('.ProductCard');

  const data = productCard.dataset;
  const { variantIds, variantOption1, media } = data;

  let variantIdsArr;
  let variantOption1Arr;
  let mediaData;
  try {
    variantIdsArr = JSON.parse(variantIds).split(',');
    variantOption1Arr = JSON.parse(variantOption1).split(',');
    mediaData = media && JSON.parse(media);
  } catch (error) {
    logger.error(error);
  }
  const colorIndices = variantOption1Arr
    .map((colr, index) => {
      if (colr === color) return index;
      return null;
    })
    .filter(Boolean);
  const filteredVariantIds = variantIdsArr.filter((_, index) => colorIndices.includes(index));

  // update buttons
  updateQuickAddBtns(productCard, filteredVariantIds);
  // // swap images
  updateImages(productCard, color, mediaData);
}

const addToCartBtns = document.querySelectorAll('[data-id="product-card-size-label"]');
const colorSwatches = document.querySelectorAll('[data-id="product-card-color-swatch"]');

function initQuickAddBtns(els) {
  els.forEach((el) => {
    el.removeEventListener('click', quickAddToCart, true);
    el.addEventListener('click', quickAddToCart, true);
  });
}

function initVariantChangeOnColor(els) {
  els.forEach((el) => {
    el.removeEventListener('mouseover', variantUpdateHandler, true);
    el.removeEventListener('click', variantUpdateHandler, true);
    el.removeEventListener('focus', variantUpdateHandler, true);
    el.addEventListener('mouseover', variantUpdateHandler, true);
    el.addEventListener('click', variantUpdateHandler, true);
    el.addEventListener('focus', variantUpdateHandler, true);
  });
}

initQuickAddBtns(addToCartBtns);
initVariantChangeOnColor(colorSwatches);

function disableAdd() {
  if (addToCartBtns) {
    addToCartBtns.forEach((btn) => {
      // eslint-disable-next-line no-param-reassign
      btn.disabled = true;
    });
  }
}

function enableAdd() {
  if (addToCartBtns) {
    addToCartBtns.forEach((btn) => {
      // eslint-disable-next-line no-param-reassign
      btn.disabled = false;
    });
  }
}

// don't allow the customer to add more to cart while cart is updating
cart.subscribe('beforeUpdate', disableAdd);
cart.subscribe('afterUpdate', enableAdd);
cart.subscribe('error', enableAdd);

// add to the window so it can be accessed in /assets directly if required
window.TASC_QUICK_ADD = {
  initAdd: initQuickAddBtns,
  initVariantSelect: initVariantChangeOnColor,
};
